import React from 'react';
import MeetingMain from 'flow/components/meeting/shared/MeetingMain';
import Page from 'flow/components/Setting/Page';

class Conference extends React.PureComponent {
    render() {
        return (
            <Page header="">
                <MeetingMain />
            </Page>
        );
    }
}

export default Conference;
